import { Routes } from '@angular/router';
import { TabsPage } from './tabs/tabs.page';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'workplace',
    loadComponent: () => import('./workplace/workplace.page').then( m => m.WorkplacePage)
  },
  {
    path: 'workplace/create-workplace',
    loadComponent: () => import('./workplace/create-workplace/create-workplace.page').then( m => m.CreateWorkplacePage)
  },
  {
    path: 'workplace-invitation',
    loadComponent: () => import('./workplace-invitation/workplace-invitation.page').then( m => m.WorkplaceInvitationPage)
  },
  {
    path: 'dashboard',
    component: TabsPage,
    children:[
      {
        path:'patient',
        loadComponent: ()=>
          import('./patient/patient.page').then((m)=>m.PatientPage)
      },
      {
        path:'staff',
        loadComponent: ()=>
          import('./staff/staff.page').then((m)=>m.StaffPage)
      },
      {
        path:'',
        redirectTo:'/dashboard/patient',
        pathMatch: 'full'
      }
    ]
    
  },
  {
    path: 'patient',
    loadComponent: () => import('./patient/patient.page').then( m => m.PatientPage)
  },
  {
    path: 'staff',
    loadComponent: () => import('./staff/staff.page').then( m => m.StaffPage)
  },
  {
    path: 'register-patient',
    loadComponent: () => import('./register-patient/register-patient.page').then( m => m.RegisterPatientPage)
  },
  {
    path: 'view-all-patient',
    loadComponent: () => import('./view-all-patient/view-all-patient.page').then( m => m.ViewAllPatientPage)
  },
  {
    path: 'view-detail-patient',
    loadComponent: () => import('./view-detail-patient/view-detail-patient.page').then( m => m.ViewDetailPatientPage)
  },
  {
    path: 'edit-patient',
    loadComponent: () => import('./edit-patient/edit-patient.page').then( m => m.EditPatientPage)
  },
  {
    path: 'medical-record',
    loadComponent: () => import('./medical-record/medical-record.page').then( m => m.MedicalRecordPage)
  },
  {
    path: 'add-medical-record',
    loadComponent: () => import('./add-medical-record/add-medical-record.page').then( m => m.AddMedicalRecordPage)
  },
  {
    path: 'edit-medical-record',
    loadComponent: () => import('./edit-medical-record/edit-medical-record.page').then( m => m.EditMedicalRecordPage)
  },
  {
    path: 'input-icd',
    loadComponent: () => import('./input-icd/input-icd.page').then( m => m.InputIcdPage)
  },
];
